// src/Dashboard/pages/user/Messaging/components/MessagingKpis.jsx

import React from "react";
import { FaEnvelopeOpenText, FaInbox, FaPaperPlane, FaUsers } from "react-icons/fa";

export default function MessagingKpis({
  receivedCount,
  sentCount,
  unreadCount,
  channelsCount,
  loading,
}) {
  const cards = [
    {
      key: "received",
      label: "Reçus",
      value: receivedCount,
      icon: FaInbox,
      tone: "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/20 dark:bg-blue-500/10 dark:text-blue-300",
    },
    {
      key: "unread",
      label: "Non lus",
      value: unreadCount,
      icon: FaEnvelopeOpenText,
      tone: "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/20 dark:bg-amber-500/10 dark:text-amber-300",
    },
    {
      key: "sent",
      label: "Envoyés",
      value: sentCount,
      icon: FaPaperPlane,
      tone: "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/20 dark:bg-emerald-500/10 dark:text-emerald-300",
    },
    {
      key: "channels",
      label: "Canaux",
      value: channelsCount,
      icon: FaUsers,
      tone: "border-indigo-200 bg-indigo-50 text-indigo-700 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
      {cards.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.key}
            className={`rounded-[24px] border px-4 py-4 shadow-sm ${card.tone}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/70 dark:bg-white/10">
                <Icon />
              </span>

              <span className="text-2xl font-bold">
                {loading ? "…" : card.value}
              </span>
            </div>

            <p className="mt-3 text-[11px] font-bold uppercase tracking-[0.16em] opacity-80">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}